<!-- Success popup styled like profile-modal -->
<div class="modal-header">
    <h4 class="modal-title">Success</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body d-flex align-items-center justify-content-center success-modal-body">
    <div class="text-center p-5">
        <img src="assets/images/success-icon.png" alt="Success" style="width:100px;margin-bottom:25px;">
        <h4 class="title profile mt-2">Success</h4>
        <p class="mt-2 mb-3">You have completed your first step in Enrolment. Please check your mail for the next step.</p>
        <button type="button" class="btn btn-primary mt-3" (click)="dismiss()">OK</button>
    </div>
</div>